import { useEffect } from "react";
import { useGetVehicleTypesQuery } from "../../api/vehicleTypes";
import { actions } from "../../redux/store/store";

export function useVehicleType() {
  const { data: vehicleTypes } = useGetVehicleTypesQuery(null, {
    refetchOnMountOrArgChange: true
  });

  useEffect(() => {
    actions.vehicleType.setVehicleTypes(
      vehicleTypes?.map((item) => ({
        value: item?._id,
        label: item?.name,
        title: item?.title
      })) || [])
  }, [vehicleTypes]);
}
